import * as React from 'react'
import Milliseconds from '../../helper/milliseconds'
import Percent from '../../helper/percent'
import LargeNumber from '../../helper/large-number'

interface Props {
    message?: {
        args: {
            calls: {
                [call: string]: {
                    ct: number
                    wt: number
                    perc: number
                }
            }
        }
    }
}

export default class CompilerOptimizedFunctions extends React.PureComponent<Props> {
    render = () => {
        const { message } = this.props

        let intro = (
            <p>
                We observed Traces with significant portions of their total time being taken up by functions that can be optimized at the
                compiler level, resulting in performance improvements.
            </p>
        )

        if (message) {
            const { args } = message

            intro = (
                <>
                    <p>These function(s) could be faster by relying on a compiler optimization</p>
                    <ul>
                        {Object.entries(args.calls).map(([call, stats]) => (
                            <li key={call}>
                                {call} (<Percent value={stats.perc} />, <Milliseconds value={stats.wt} />,{' '}
                                <LargeNumber value={stats.ct} useUnitClass={false} /> invocations)
                            </li>
                        ))}
                    </ul>
                </>
            )
        }

        return (
            <div>
                {intro}
                <p>
                    See the{' '}
                    <a href="https://support.tideways.com/documentation/reference/observations/compiler-optimized-functions.html?utm_medium=app&utm_source=bottlenecks&utm_campaign=compiler-optimized-hint">
                        documentation
                    </a>{' '}
                    for more information on compiler optimized functions.
                </p>
            </div>
        )
    }
}
